import { getData } from '@/utils/axiosUtils';

export const getAvailableRegions = async () =>
    await getData('/TRSRegistrars/AvailableRegions', { 'X-RequestScope': 20 });
